export const allPhotos = [
  {
    id: 1,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/dfee14f4-55e0-42f8-b8df-6d8357e54a3a_0d1dd461-d7df-43d8-b477-5eb3d1c16348.jpg?v=83aa31b0937596b88a818c3823c14839",
    label: "Piscina Residencial",
    category: "Piscinas",
  },
  {
    id: 2,
    src: "https://static.readdy.ai/image/6a7579bc8d43d0a6c72897fa8ac6995d/08372fd9a32242e02ea59b0ac2258462.png",
    label: "Proyecto Completado",
    category: "Piscinas",
  },
  {
    id: 3,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/731f343a-f91b-42d3-8c91-7fdfbc0ef6e9_3af029a9-1a7c-46d8-82b2-353ec228d41c.jpg?v=60bead76068423ea8b44a00ae399ef9f",
    label: "Diseño Personalizado",
    category: "Piscinas",
  },
  {
    id: 4,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/6cfa8c46-c02a-426e-87fd-f99576b55854_19f1323b-be76-436c-ad05-108a58d90d23.jpg?v=2f1a8bb6e507077c83f654ff9f6cd68b",
    label: "Construcción en Proceso",
    category: "Construcción",
  },
  {
    id: 5,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/050727ad-735c-4ca1-b4de-1b45114f5653_649e35f1-855a-4848-85db-11b15d3ecd17.jpg?v=085a83a5680035ceb4be57429125ae68",
    label: "Acabados Premium",
    category: "Piscinas",
  },
  {
    id: 6,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/b8468e74-f5dd-48d3-bf0a-df27f35236e8_2286fa78-509c-4d51-a2d3-2747d1320db9.jpg?v=cf9f72f4bf8533521106aa503d44c573",
    label: "Piscina con Terraza",
    category: "Piscinas",
  },
  {
    id: 7,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/0f62491f-224a-4fd2-aceb-ebea05647b21_3003a6fc-ba12-44f3-835b-40083c2a758c.jpg?v=3de372834138130cbbd78233555c8862",
    label: "Instalación Completa",
    category: "Construcción",
  },
  {
    id: 8,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/6d0c8700-c06f-4b7e-8987-735c93b7bef8_C9EC9A18-CC3D-4467-BDC0-87E77AC7D5A4.jpg?v=9b6097f40147e28552ce718ee59607be",
    label: "Vista Panorámica",
    category: "Piscinas",
  },
  {
    id: 9,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/6843b3a6-536f-4b47-8e94-7756189af5f0_cb6c8ae0-1ccc-47d2-950e-44f21545064a.jpg?v=cda11c4117f1e74bba8626594b4d57de",
    label: "Obra Residencial",
    category: "Construcción",
  },
  {
    id: 10,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/32cbc069-ea96-4bb3-b412-2b40053ff29c_Drone-2.jpg?v=54042e138603493be72bdbefe7cacb7f",
    label: "Vista Aérea",
    category: "Aéreas",
  },
  {
    id: 11,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/e1ab85d4-64f0-452d-b830-2b3b1f57f3dc_Drone-3.jpg?v=b4e0d48debb2017d898bf4c2261d41ce",
    label: "Toma Aérea Drone",
    category: "Aéreas",
  },
  {
    id: 12,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/a7403707-56ec-4412-861e-3c8b26862716_E54ACE42-DC09-4345-974A-2B2A3AE5B128.jpg?v=326fd888b31a7413ed818c1fac8f9065",
    label: "Proyecto Finalizado",
    category: "Piscinas",
  },
  {
    id: 13,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/383e2a59-2520-4582-8bd8-b6433d5e12c7_fcdb123b-2eb5-4f1e-824b-8070d29f74a8.jpg?v=2e467e742a716b24aa3ce34e3013b3ad",
    label: "Piscina Moderna",
    category: "Piscinas",
  },
  {
    id: 14,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/c5288b4d-6e7c-4a7d-8adf-58262e70b53f_IMG_2339.jpg?v=4f2d02fc996f72ced7d80f8ef110f6b8",
    label: "Detalle de Obra",
    category: "Construcción",
  },
  {
    id: 15,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/ec4d912b-0548-423c-ac59-e2c1530785c0_IMG_2340.jpg?v=3a1ad512e2592fe431f2a91c083b1761",
    label: "Proceso Constructivo",
    category: "Construcción",
  },
  {
    id: 16,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/54cd8944-8da0-450a-a359-b00dd5596644_IMG_5637.jpg?v=5ca9feeb160041c2447a86b47d717fc3",
    label: "Obra en Progreso",
    category: "Construcción",
  },
  {
    id: 17,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/7438bfde-4ee6-43c8-9f95-12ea8b5a650c_IMG_5649.jpg?v=34e1c2dacd8c84be47cf6f8526c7737f",
    label: "Terminación y Acabado",
    category: "Piscinas",
  },
  {
    id: 18,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/32838c46-2cc9-4b20-b962-6ff7007a290f_IMG_6846.jpg?v=76cc1c6522d1f4710302aa06983bb12a",
    label: "Instalación de Sistema",
    category: "Construcción",
  },
  {
    id: 19,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/eb3cda45-40fb-4f49-9666-d2e2ce9c8051_IMG_6848.jpg?v=afedb378f42443e95ae0d7dea1fd8b66",
    label: "Detalles Técnicos",
    category: "Construcción",
  },
  {
    id: 20,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/45a421d3-2fab-402d-ad23-daa9071c553f_IMG_8160.jpg?v=86362d453ce91928bc737897daa64c46",
    label: "Piscina Lista",
    category: "Piscinas",
  },
  {
    id: 21,
    src: "https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/8877d94d-f399-45ef-ac3e-81135cff482e_IMG_8185.jpg?v=6aeadca1bf30882d88a5ec016226bf8e",
    label: "Entrega Final",
    category: "Piscinas",
  },
];

export const categories = ["Todos", "Piscinas", "Construcción", "Aéreas"];